import { action, computed, observable } from "mobx";

export type OnStateCallback<T extends string> = (fsm: StateMachine<T>) => any;

export class StateMachine<T extends string> {
  @observable protected _state: T;
  private _onHandlers: Partial<Record<T, Array<OnStateCallback<T>>>> = {};

  @computed get state() {
    return this._state;
  }

  constructor(initial: T) {
    this._state = initial;
  }

  is(...v: T[]) {
    return Array.isArray(v) ? v.includes(this._state) : this._state === v;
  }

  @action transition(s: T) {
    this._state = s;
    this._runOnHandlers(this._state);
  }

  on(v: T, cb: OnStateCallback<T>) {
    this._onHandlers[v] = this._onHandlers[v] || [];
    this._onHandlers[v].push(cb);
  }

  private _runOnHandlers(state: T) {
    const handlers = this._onHandlers[state] || [];

    handlers.forEach((handler) => handler(this));
  }
}
